import { get } from "Components/Device/Flow/constants";
import { FlowPortProps, FlowWidgetProps } from "Components/Device/Flow/types";
import "Components/Device/Flow/widget.css";
import useCheckRole from "Hooks/APICheckRole";
import { useDevice } from "Hooks/Endpoints";
import React from "react";
import { Icon, Label, Popup } from "semantic-ui-react";

const Ports = ({ ports }: FlowPortProps) => {
  return (
    <div className='item'>
      {ports.map((port) =>
        React.cloneElement(port, {
          style: {
            width: "0px",
            height: "0px",
          },
        })
      )}
    </div>
  );
};

const FlowWidget = ({ inputs, outputs, data: { device } }: FlowWidgetProps) => {
  const { select, device: selectedDevice } = useDevice();
  const { hasRole, getDeviceRoles } = useCheckRole();
  const widget = get(device.type);

  const inner = (
    <div
      className={`widget-container ${
        selectedDevice?.id === device.id ? "gradient-border" : ""
      }`}
    >
      <Ports ports={inputs} />
      <div style={{ flexGrow: 1 }}>
        <Label
          as='a'
          image
          color={widget.color}
          size='medium'
          onClick={(event, data) => {
            const r = getDeviceRoles(device.type).edit;
            if (hasRole(r)) {
              select(device.id);
            }
          }}
        >
          <Icon name={widget.icon} />
          {device.extension}
          <Label.Detail style={{ minWidth: "100px" }}>
            {device.name.substring(0, 10)}
          </Label.Detail>
        </Label>
      </div>
      <Ports ports={outputs} />
    </div>
  );
  return (
    <Popup trigger={inner}>
      <Popup.Header>{device.name}</Popup.Header>
    </Popup>
  );
};

export default FlowWidget;
